import type { ReactNode } from 'react';
import { LoadingScreen } from '@planitgeo/treeplotter-ui-library';

export function isAutomationEnvironment(): boolean {
  if (typeof navigator === 'undefined') return false;
  return (navigator as Navigator & { webdriver?: boolean }).webdriver === true;
}

/** Fallback for Loadable: null in Playwright/automation to avoid blocking backdrop, otherwise LoadingScreen. */
export function loadableFallback(): ReactNode {
  return isAutomationEnvironment() ? null : <LoadingScreen />;
}
